import HomePage from '../src/pages/HomePage'
import Accueil from '../src/pages/Accueil'
import Court from '../src/pages/Court'
import Palmares from '../src/pages/Palmares'
import Pass from '../src/pages/Pass'
import Memory from '../src/pages/Memory'
import Zeria from '../src/pages/Zeria'
import Watcher from '../src/pages/Watcher'
import Nocebo from '../src/pages/Nocebo'
import Piaffe from '../src/pages/Piaffe'
import Pieta from '../src/pages/Pieta'
import Blood from '../src/pages/Blood'
import Tour from '../src/pages/Tour'
import Montagne from '../src/pages/Montagne'
import MagicWord from '../src/pages/MagicWord'
import LumiereResume from '../src/pages/LumiereResume'
import Programme from '../src/pages/Programme'
import Bravo from '../src/pages/Bravo'
import Algues from '../src/pages/Algues'
import Growing from '../src/pages/Growing'
import Racines from '../src/pages/Racines'
import Machine from '../src/pages/Machine'
import Palmares23 from '../src/pages/Palmares23'
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

function App() {
  return (
    <div>
      <Router>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/accueil' element={<Accueil />} />
            <Route path='/court' element={<Court />} />
            <Route path='/pass' element={<Pass />} />
            <Route path='/palmares' element={<Palmares />} />
            <Route path='/memory' element={<Memory />} />
            <Route path='/zeria' element={<Zeria />} />
            <Route path='/watcher' element={<Watcher />} />
            <Route path='/nocebo' element={<Nocebo />} />
            <Route path='piaffe' element={<Piaffe />} />
            <Route path='/pieta' element={<Pieta />} />
            <Route path='/blood' element={<Blood />} />
            <Route path='/tour' element={<Tour />} />
            <Route path='/montagne' element={<Montagne />} />
            <Route path='/magicWord' element={<MagicWord />} />
            <Route path='/lumiereResume' element={<LumiereResume />} />
            <Route path='/programme' element={<Programme />} />
            <Route path='/bravo' element={<Bravo />} />
            <Route path='/algues' element={<Algues />} />
            <Route path='/racines' element={<Racines />} />
            <Route path='/growing' element={<Growing />} />
            <Route path='/palmares23' element={<Palmares23 />} />
            <Route path='/machine' element={<Machine />} />
            <Route path='/passChachou' component={() => {
    window.location.href = 'https://www.weezevent.com/espacemembreauth/login';
}}/>
          </Routes>
      </Router>
    </div>
  );
}

export default App;
